import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Typography } from '@mui/material';
import TitleBar from '../_common/TitleBar';
import Breadcrumbs from '../_common/Breadcrumbs';
import ProfileBuilderForm from './ProfileBuilderForm';
import axios from '../../_utils/axios';
import { selectCanWriteProfiles } from '@/redux/selectors/authSelectors';
import { useAppSelector } from '@/redux/hooks';

const ProfileBuilder = () => {
  const history = useHistory();
  const canCreateProfile = useAppSelector(selectCanWriteProfiles);

  const saveProfile = (data) => {
    return axios
      .post('/core/profile_templates/create/', data)
      .then((res) => {
        const id = res.data?.data?.id;
        history.push(`/profiles/${id}`);
      })
      .catch((err) => Promise.reject(err));
  };

  return (
    <div>
      <TitleBar>
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/profiles">Customer Profiles</Link>
          {canCreateProfile && <Typography variant="h3">New Profile</Typography>}
        </Breadcrumbs>
      </TitleBar>

      <ProfileBuilderForm saveProfile={saveProfile} />
    </div>
  );
};

export default ProfileBuilder;
